<ng-container *ngIf="operationState$ | async as operation" [xOperation]="operation">
  <ng-container *ngIf="isInWishlist$ | async; else ELSE">
    <button
      mat-icon-button
      (click)="action('remove', operation)"
      [disableRipple]="true"
      class="active"
      matTooltip="Remove from favourites"
      matTooltipClass="accent"
      [xButtonSize]="buttonSize"
    >
      <fa-icon class="heart" icon="heart" [xIconSize]="iconSize"></fa-icon>
    </button>
  </ng-container>

  <ng-template #ELSE>
    <button
      mat-icon-button
      [disableRipple]="true"
      (click)="action('add', operation)"
      matTooltip="Add to favourites"
      matTooltipClass="accent"
      [xButtonSize]="buttonSize"
    >
      <fa-icon class="heart" icon="heart" [xIconSize]="iconSize"></fa-icon>
    </button>
  </ng-template>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>
